const NotificationIcon = () => {
  return (
    <svg width='41' height='40' viewBox='0 0 41 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.5 30C21.6 30 22.5 29.1 22.5 28H18.5C18.5 29.1 19.4 30 20.5 30ZM26.5 24V19C26.5 15.93 24.87 13.36 22 12.68V12C22 11.17 21.33 10.5 20.5 10.5C19.67 10.5 19 11.17 19 12V12.68C16.14 13.36 14.5 15.92 14.5 19V24L12.5 26V27H28.5V26L26.5 24ZM24.5 25H16.5V19C16.5 16.52 18.01 14.5 20.5 14.5C22.99 14.5 24.5 16.52 24.5 19V25Z'
        fill='#F7F8F8'
      />
    </svg>
  )
}

export default NotificationIcon
